var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.hasRoomingList)?_c('v-tooltip',{attrs:{"top":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"small":""}},on),[_vm._v("night_shelter")])]}}],null,false,1590388869)},[_vm._v(" Has rooming list ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }